import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const download = async (id: string, fileName: string) => {
  const element = document.getElementById(id);
  if (!element) return;

  const scale = 3;
  const canvas = await html2canvas(element, { scale });
  const pdf = new jsPDF('p', 'pt', 'a4');

  const pageWidth = 595.28;
  const pageHeight = 841.89;
  const margin = 30;

  const usableWidth = pageWidth - margin * 2;
  const ratio = usableWidth / canvas.width;
  const usableHeight = pageHeight - margin * 2;
  const pageHeightPx = usableHeight / ratio;

  const contentElements: HTMLElement[] = Array.from(
    element.querySelectorAll('tr, h2, div, p')
  );

  const parentRect = element.getBoundingClientRect();

  const elementOffsets: { top: number; el: HTMLElement }[] =
    contentElements.map(el => {
      const rect = el.getBoundingClientRect();
      return {
        top: Math.round((rect.top - parentRect.top) * scale),
        el
      };
    });

  // End marker
  elementOffsets.push({
    top: canvas.height,
    el: document.createElement('div')
  });

  let startY = 0;
  let pageAdded = false;

  for (let i = 0; i < elementOffsets.length - 1; i++) {
    const { top: elStart, el } = elementOffsets[i];
    const elEnd = elementOffsets[i + 1].top;

    const newPageIds = [
      'costSavingsInterventionProvider',
      'savingsBySector',
      'costSavingsIntervention',
      'healthyStepsOverview'
    ];

    const isNewPage = el.id && newPageIds.includes(el.id);

    // ---------- FORCE NEW PAGE ----------
    if (isNewPage && startY !== elStart) {
      const sliceHeight = elStart - startY;
      if (sliceHeight > 0) {
        addSlice(canvas, pdf, startY, sliceHeight, usableWidth, ratio, margin, pageAdded);
        pageAdded = true;
      }
      startY = elStart;
    }

    // ---------- PAGE OVERFLOW ----------
    if (elEnd - startY > pageHeightPx) {

      // 🔥 KEY FIX: Snap to element start to avoid text cut
      const sliceHeight = elStart - startY;

      if (sliceHeight > 0) {
        addSlice(canvas, pdf, startY, sliceHeight, usableWidth, ratio, margin, pageAdded);
        pageAdded = true;
        startY = elStart;

        // Re-check same element on next page
        i--;
      }
    }
  }

  // ---------- LAST PART ----------
  if (startY < canvas.height) {
    const sliceHeight = canvas.height - startY;
    addSlice(canvas, pdf, startY, sliceHeight, usableWidth, ratio, margin, pageAdded);
  }

  pdf.save(`Report - ${fileName}.pdf`);
};

function addSlice(
  canvas: HTMLCanvasElement,
  pdf: jsPDF,
  startY: number,
  sliceHeight: number,
  usableWidth: number,
  ratio: number,
  margin: number,
  pageAdded: boolean
) {
  const sliceCanvas = document.createElement('canvas');
  sliceCanvas.width = canvas.width;
  sliceCanvas.height = sliceHeight;

  const ctx = sliceCanvas.getContext('2d')!;
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, sliceCanvas.width, sliceCanvas.height);

  ctx.drawImage(
    canvas,
    0,
    startY,
    canvas.width,
    sliceHeight,
    0,
    0,
    canvas.width,
    sliceHeight
  );

  const imgData = sliceCanvas.toDataURL('image/jpeg', 1.0);

  if (pageAdded) pdf.addPage();

  pdf.addImage(
    imgData,
    'JPEG',
    margin,
    margin,
    usableWidth,
    sliceHeight * ratio
  );
}

export default { download };